var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow/up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-48.000000, -559.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Arrow/Up",
    transform: "translate(48.000000, 559.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD044",
    d: "M3.77290426,13.4964848 L2.80680257,12.5055239 C2.39773248,12.0859279 2.39773248,11.4074322 2.80680257,10.9923 L11.2623683,2.31469702 C11.6714384,1.89510099 12.3329134,1.89510099 12.7376317,2.31469702 L21.1931974,10.9878362 C21.6022675,11.4074322 21.6022675,12.0859279 21.1931974,12.5010601 L20.2270957,13.492021 C19.8136738,13.9160808 19.1391434,13.9071532 18.7344251,13.4741658 L13.7428997,8.09976565 L13.7428997,20.928691 C13.7428997,21.5223747 13.2772561,22 12.6984654,22 L11.3058864,22 C10.7270957,22 10.2614521,21.5223747 10.2614521,20.928691 L10.2614521,8.09976565 L5.2655749,13.4786296 C4.86085662,13.9160808 4.18632616,13.9250084 3.77290426,13.4964848 Z",
    id: "Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow-up.63107dae.svg";
export { ForwardRef as ReactComponent };